import { gql } from "@apollo/client";

export const JUSTIFICAR_MINUTA = gql`
mutation JustificarMinuta (
    $idMinuta: Int!,
    $idJustificacion: Int!,
  
){
    justificarMinuta (
        idMinuta: $idMinuta,
        idJustificacion: $idJustificacion
    ) {
      success,
      valorEsperado,
      error
    }
}
`;